module.exports = __webpack_public_path__ + "img/delete_2.6e99b5d7.jpg";